<template>
  <div class="widget-video web-video-xd">
    <div ref="xdvideo" class="web-video-xd" :data-options="optionsStr" />
    <canvas v-if="needHack" width="0" height="0" style="display: none"></canvas>
    <!-- <ImageMask v-if="imageMask.enabled" :image-mask="imageMask" /> -->
  </div>
</template>
<script setup>
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, useTemplateRef } from 'vue'
import * as api from '@/service/index'
import { useAppStore } from '@/store'
// import ImageMask from '../default/image-mask.vue';

defineOptions({
  name: 'WidgetVideoNuxt'
})

const props = defineProps({
  feedBackStatus: {
    type: Function,
    default: () => {}
  },
  liveInfo: {
    type: Object,
    default: () => {}
  }
})

const appStore = useAppStore()

const xdvideo = useTemplateRef('xdvideo')

const needHack = ref(false)
const pid = ref('')
// 播放器实例：原选项式 data 中同样为响应式，保持 ref 以保证行为一致
const player = ref(null)
const options = reactive({
  controls: true,
  loop: true,
  poster: '',
  muted: true,
  autoplay: true,
  scrollAutoPlay: false,
  autoFullScreen: false,
  preload: false
})
const status = ref(false)
const sourceType = ref('') // video/mp4  application/x-mpegURL
const localePath = ref([])
const wantStatus = reactive({
  play: false,
  loop: true,
  fullScreen: false
})

const timerCount = ref(1)
const timer = ref(null)
const closeTimer = ref(true)
// 状态锁
const isUpdating = ref(false)
// 已获取到的时间戳
const countMiles = ref(0)

const fullScreen = computed(() => appStore.fullScreen)
const token = computed(() => appStore.token)

const sources = computed(() => {
  let result = []
  localePath.value.map(({ key, value }) => {
    if (key !== 'poster' && value) {
      result.push({
        label: key.toUpperCase(),
        src: value,
        type: sourceType.value
      })
    }
  })
  return result
})

const optionsStr = computed(() => {
  return JSON.stringify({ ...options, sources: sources.value })
})

// 原选项式 watch 的 `poster` 在组件状态上并不存在（始终为 undefined），该回调从不触发；
// 此处保留等效的“永不触发”写法以不改变运行行为
watch(
  () => undefined,
  () => {
    if (player.value) {
      player.value.poster(undefined)
    }
  }
)
// 全屏状态切换时给自定义全屏按钮加/去 state class, SCSS 里两态各自 sprite
watch(fullScreen, (isFullScreen) => {
  const btn = document.querySelector('.vjs-live-fullscreen-control')
  if (btn) btn.classList.toggle('is-fullscreen', isFullScreen)
})

watch(sources, (newVal) => {
  if (player.value) {
    player.value.VideoControl().updateNormalSource(newVal)
  }
})
watch(
  () => props.liveInfo,
  (newVal) => {
    const { screenshot, ld, hd, fhd, type } = newVal
    options.poster = screenshot

    let arr = [
      { key: 'ld', value: ld },
      { key: 'hd', value: hd },
      { key: 'fhd', value: fhd },
      { key: 'poster', value: screenshot }
    ]
    localePath.value = arr

    sourceType.value = type
  },
  {
    immediate: true,
    deep: true
  }
)

onMounted(() => {
  // 添加任意 canvas 或者视频宽度在 [21, 179] 之间时，qq x5 浏览器 在 vivo 手机上可以隐藏控件
  if (!window.__XDVIDEO__) {
    // const { CONSTANT } = window.moo;
    // if (CONSTANT.IS_ANDROID && CONSTANT.IS_BROWSER_QQ) this.needHack = true;
    (function (w, d, t, r) {
      w['__WEB_VIDEO_OBJECT__'] = r
      w[r] =
        w[r] ||
        function () {
          (w[r].cmd = w[r].cmd || []).push(arguments)
        }
      var n = d.createElement(t),
        m = d.getElementsByTagName(t)[0]
      var j = d.createElement('link')
      j.rel = 'stylesheet'
      j.type = 'text/css'
      j.href = 'https://res.xdcdn.net/video/xdvideo-player.css'
      m.parentNode.insertBefore(j, m)
      n.async = 1
      n.src = 'https://res.xdcdn.net/video/xdvideo-player.min.js'
      m.parentNode.insertBefore(n, m)
    })(window, document, 'script', '__XDVIDEO__')
  }
  window.__XDVIDEO__('register', {
    pick: xdvideo.value,
    afterCreate: handleAfterCreate,
    onError: (e) => {
      console.log(e)
    }
  })
})

function play() {
  if (status.value) return
  if (!player.value) return
  player.value.autoplay('any')
}
function pause() {
  player.value && player.value.pause()
}
function handleAfterCreate(videojs) {
  let newPid = videojs.getPid(xdvideo.value)
  if (newPid === pid.value) return
  pid.value = newPid
  player.value = videojs.getPlayer(newPid)
  if (!player.value) return
  // this.rocketEmit('rocket:video:ready', true);
  videoReady()
  player.value.on('playing', () => updateStatus())
  // 暂停视频不在上报时间
  // this.player.on('pause', () => this.updateStatus());
  player.value.on('ended', () => {
    // this.rocketEmit('rocket:video:ended', true);
  })
  player.value.on('fullscreenchange', (e) => handleFullscreenChange(e))
  player.value.on('error', () => props.feedBackStatus(2, false))
  // 在初始化完成之前执行的动作，进行补救
  if (wantStatus.play && !options.autoplay) {
    play()
  }
  if (wantStatus.fullScreen) {
    player.value.requestFullscreen()
  }
  if (wantStatus.loop !== options.loop) {
    player.value.loop(wantStatus.loop)
  }
}
function updateStatus() {
  // console.log('updateStatus',this.isUpdating);
  if (!isUpdating.value) {
    // console.log('updateStatus1',this.isUpdating);
    isUpdating.value = true
    timer.value = setInterval(() => {
      // 每次执行15次，且需要在要直播页，且观看时间小于120分钟
      if (timerCount.value <= 120 && closeTimer.value && countMiles.value < 120) {
        // 当前播放器的状态
        let playStatus = !player.value.paused()
        // 说明当时在播放
        if (playStatus !== status.value) {
          // console.log('我在播放');
          // this.initTime();
          reportMinutes()
          timerCount.value++
        } else {
          // this.isUpdating = false;
          clearInterval(timer.value)
        }
      } else {
        clearInterval(timer.value)
      }
      isUpdating.value = false
    }, 60000)
  }
  // 被执行了两次
}
function handleFullscreenChange() {
  // this.rocketEmit(
  //   'rocket:video:fullscreenchange',
  //   true,
  //   this.player.isFullscreen()
  // );
}
function reportMinutes() {
  // console.log('this.time.play',this.time.play);
  // if (this.time.play !== "") {
  // }
  api
    .reqcurrentTime()
    .then((response) => {
      // console.log('response',response);
      if (response.status === 200) {
        // this.time.pause = response.data;
        // 观看1分钟以上为有效数据
        let data = {
          minutes: 1
          // token: decodeURIComponent(),
        }
        // console.log('data',data);
        let tokenVal = token.value
        // console.log('观看成功');
        api.reportMinutes(tokenVal, data)

        // 埋点
        if (typeof tapdb === 'undefined') return
        tapdb.trackEvent('观看直播', {
          '#duration': 1
        })
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
function handleFullScreen() {
  appStore.fullScreen = !fullScreen.value
}
function videoReady() {
  const $controlBar = document.getElementsByClassName(
    'vjs-control-bar-right'
  )[0]
  if (!$controlBar) return
  const existingControl = $controlBar.querySelector('.vjs-live-fullscreen-control')
  if (existingControl) {
    existingControl.remove()
  }
  const fullscreenControl = document.createElement('div')
  fullscreenControl.className = 'vjs-live-fullscreen-control'
  fullscreenControl.innerHTML = '<i></i>'
  fullscreenControl.addEventListener('click', () => {
    handleFullScreen()
  })
  $controlBar.append(fullscreenControl)
}
async function fetchUserInfo() {
  if(!token.value) return;
  try {
    const req = await api.reqUserInfo({ token: token.value ,force: true})
    countMiles.value = req.data.viewTime
  } catch (err) {
    console.log(err)
  }
}

// created
fetchUserInfo()

onBeforeUnmount(() => {
  closeTimer.value = false
})

// 父组件（live/index.vue）通过 $refs.videoPlayer 调用
defineExpose({
  play,
  pause
})
</script>
<style lang="scss" scoped>
.web-video-xd {
  height: 100%;
  background: transparent;
  padding: 0;
  flex-grow: 1;
  :deep(video) {
    object-fit: var(--rocket-video-object-fit, contain);
    outline: none;
  }
}
.widget-video {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex-direction: column;
  &.rocket-video-without-pip {
    :deep(.vjs-picture-in-picture-control) {
      display: none;
    }
  }
  :deep(.video-js) {
    background-color: transparent;
    .vjs-modal-dialog {
      background: transparent;
    }
    &.vjs-controls-disabled {
      .vjs-loading-spinner,
      .vjs-error-display {
        display: none;
      }
    }
    .vjs-time-control {
      display: none;
    }

    .vjs-control-bar {
      background-color: rgba(31, 31, 31, 0.5);
      // 不知道为啥左右留了空，先补上了
      left: 0;
      right: 0;
      .vjs-live-control {
        .vjs-live-display {
          display: none;
        }
      }
      .vjs-audio-button,
      .vjs-at-live-edge,
      .vjs-seek-to-live-control,
      .vjs-fullscreen-control,
      .vjs-picture-in-picture-control {
        display: none;
      }

      .vjs-live-fullscreen-control {
        position: relative;
        width: 40px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          display: inline-block;
          width: 22px;
          height: 22px;
          background: url('https://website.xdcdn.net/module/sausage-match/images/live/full.png') center/contain no-repeat;
        }
        // 全屏中: 切换到"退出全屏" icon
        &.is-fullscreen i {
          background-image: url('https://website.xdcdn.net/module/sausage-match/images/live/unfull.png');
        }
      }
    }

    .vjs-error-display {
      display: none;
    }
  }
  .vjs-poster {
    background-size: cover;
  }
  &.rocket-video-playing {
    :deep(.image-mask) {
      display: none;
    }
  }
}
</style>
